import { render } from "./signup-1.vue?vue&type=template&id=25dbbafc&scoped=true"
import script from "./signup-1.vue?vue&type=script&lang=js"
export * from "./signup-1.vue?vue&type=script&lang=js"

import "./signup-1.vue?vue&type=style&index=0&id=25dbbafc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25dbbafc"]])

export default __exports__